import {
    addDays,
    addWeeks,
    endOfDay,
    endOfMonth,
    endOfWeek,
    startOfDay,
    startOfMonth,
    startOfWeek,
    subMonths,
} from 'date-fns';
import { DatePeriod } from '../types';

// eslint-disable-next-line import/prefer-default-export
export const getDatesFromPeriod = (
    period: DatePeriod,
    isStartOfDay?: boolean,
    isEndOfDay?: boolean,
) => {
    let startDate = new Date();
    let endDate = new Date();
    switch (period) {
        case DatePeriod.TODAY:
            break;
        case DatePeriod.YESTERDAY:
            startDate = addDays(startDate, -1);
            endDate = startDate;
            break;
        case DatePeriod.THIS_WEEK:
            startDate = startOfWeek(startDate);
            break;
        case DatePeriod.PAST_7_DAYS:
            startDate = addDays(startDate, -7);
            break;
        case DatePeriod.LAST_WEEK:
            startDate = startOfWeek(addWeeks(startDate, -1));
            endDate = endOfWeek(startDate);
            break;
        case DatePeriod.PAST_30_DAYS:
            startDate = addDays(startDate, -30);
            break;
        case DatePeriod.PAST_60_DAYS:
            startDate = addDays(startDate, -60);
            break;
        case DatePeriod.PAST_90_DAYS:
            startDate = addDays(startDate, -90);
            break;
        case DatePeriod.PAST_180_DAYS:
            startDate = addDays(startDate, -180);
            break;
        case DatePeriod.THIS_MONTH:
            startDate = startOfMonth(startDate);
            break;
        case DatePeriod.LAST_MONTH:
            startDate = startOfMonth(subMonths(startDate, 1));
            endDate = endOfMonth(startDate);
            break;
        default:
            break;
    }
    if (isStartOfDay) {
        startDate = startOfDay(startDate);
    }
    if (isEndOfDay) {
        endDate = endOfDay(endDate);
    }
    return {
        period,
        startDate,
        endDate,
    };
};
